








import { Component, Vue } from 'vue-property-decorator'
import { TagsViewStoreModule as tagsViewStore } from '@/shared/config/store/tags-view-store'

@Component({
  name: 'AppMain'
})
export default class extends Vue {
  get cachedViews() {
    return tagsViewStore.cachedViews
  }

  get key() {
    return this.$route.fullPath
  }
}
